// Formats an invitation code like the campaign detail screen does:
// XXXX-XXXX-XXXX for 12 characters, XXX-XXX-XXX for 9, '-' otherwise.
const formatCandidateCode = (rawCode) => {
  const code = typeof rawCode === 'string' ? rawCode.toUpperCase() : '';
  if (code.length === 12) {
    return `${code.substring(0, 4)}-${code.substring(4, 8)}-${code.substring(
      8,
      12,
    )}`;
  }
  if (code.length === 9) {
    return `${code.substring(0, 3)}-${code.substring(3, 6)}-${code.substring(
      6,
      9,
    )}`;
  }
  return '-';
};

export default formatCandidateCode;
